import React from 'react';
import {Col, Row, Collapse, Tag, Icon, Button, Popover, DatePicker, message} from 'antd'
import {_generateGantt, _postNewDateScheduled, _postNewDeliveryMode} from '../../services';

import moment from 'moment';
import { StopTag } from './CollapsePanelContent';
const { Panel } = Collapse;
const { RangePicker } = DatePicker;


class DeliveryRoutesTable extends React.Component{

    constructor(props){
        super(props)
        this.state={
			dateRange: null,
			countPerDay: [],
			table: null,
			selectedLocations:[],
			datePickerPopover: false,
			scheduledDate: null,
			filterDateRange: [moment().subtract(7,'day') , moment().add(7,'day')],
			focusDate: null
        }
    }
		componentDidMount(){
			message.loading('loading... This takes awhile', 0)
			_generateGantt(this.state.filterDateRange)
			.then(res=>{
				message.destroy()
				message.success('Showing all uncompleted orders')
				this.setState({
					dateRange: res.data.date,
					table: res.data.table,
					countPerDay: res.data.countPerDay
				})
			})
			.catch(e=>console.log(e))
		}

    render(){
			let cellWidth = this.state.dateRange && `50px`
			return(
				<div>
				<table style={{fontSize:'10px'}} >
					<thead >
						<tr>
							 <th style={{position:'sticky',"opacity":0.9, top:0, backgroundColor:'#ffff'}}>
								Month
							</th>
							{this.state.dateRange && this.state.dateRange.map(date=>
								<th style={{width:cellWidth, textAlign:'center', borderLeft:'1px black solid', padding:'10px', position:'sticky',"opacity":0.9, top:0, backgroundColor:'#ffff', zIndex:999999}}>
									{moment(date).format('MMMM')}
								</th>
							)}
						</tr>	
						<tr>
							 <th style={{position:'sticky',"opacity":0.9, top:30, backgroundColor:'#ffff'}}>
								Date
							</th>
							{this.state.dateRange && this.state.dateRange.map(date=>
								<th style={{width:cellWidth, textAlign:'center', borderLeft:'1px black solid', padding:'10px', position:'sticky',"opacity":0.9, top:30, backgroundColor:'#ffff', zIndex:999999}}>
									{moment(date).format('DD')}
								</th>
							)}
						</tr>
						<tr >
							 <th style={{position:'sticky',"opacity":0.9, top:60, backgroundColor:'#ffff'}}>
								Day
							</th>
							{this.state.dateRange && this.state.dateRange.map(date=>
								<th style={{width:cellWidth, textAlign:'center', borderLeft:'1px black solid', padding:'10px',position:'sticky',"opacity":0.9, top:60, backgroundColor:'#ffff', zIndex:999999}}>
									{moment(date).format('dddd')}
								</th>
							)}
						</tr>
						<tr>
							<th style={{position:'sticky',"opacity":0.9, top:90, backgroundColor:'#ffff'}}>
								Focus On
							</th>
							{this.state.dateRange && this.state.dateRange.map((date, i)=>
								<th style={{width:cellWidth, textAlign:'center', borderLeft:'1px black solid', padding:'10px', position:'sticky',"opacity":0.9, top:90, backgroundColor:'#ffff', zIndex:999999}}>
									<Button type={this.state.focusDate === date && "primary"} onClick={(e)=>this.onFocusDate(e, date)}>
										Focus
									</Button>
								</th>
							)}
						</tr>
						<tr>
							 <th style={{position:'sticky',"opacity":0.9, top:140, backgroundColor:'#ffff'}}>
								Eezee Send
							</th>
							{this.state.countPerDay && this.state.countPerDay.map(count=>
								<th style={{width:cellWidth, textAlign:'center', borderLeft:'1px black solid', padding:'10px', position:'sticky',"opacity":0.9, top:140, backgroundColor:'#ffff', zIndex:999999}}>
									{count}
								</th>
							)}
						</tr>	
					</thead>
					<tbody>
						{
							this.state.table && Object.keys(this.state.table).sort().map(inv=>{
								
								let style={
									borderLeft:'1px solid black', 
									width:cellWidth
								}
								return(
									<tr style={{borderBottom:'1px black solid'}} key={inv}>
										<td style={{position:'sticky',"opacity":0.9, left:0, backgroundColor:'#ffff', zIndex:999998, padding:'10px'}}>
											{inv}
										</td>
										{
											this.state.table[inv].map((loc, index)=>{
												if(loc){
													if( loc.datePurchased || loc.deliveryDate){
														let fillStyle = {...style}
														fillStyle["backgroundColor"] = "#eaff8f"
														fillStyle["padding"] = "10px"
														return(
															<td style={fillStyle} key={loc._id}>
																{loc.datePurchased && `Date Purchased ${loc.datePurchased}`}
																{loc.deliveryDate && `Max Delivery Date${loc.deliveryDate}`}
															</td>
														)
													}
												}
												
												
												
												if(loc === null){
													return(
														<td style={style}>
														</td>
													)
												}
												if(loc === "fill"){
													let fillStyle = {...style}
													fillStyle["backgroundColor"] = "#eaff8f"
													return(
														<td style={fillStyle}>
														</td>
													)
												}
												if(loc && loc != "fill" && loc.length>0 && !loc.datePurchased && !loc.deliveryDate){
													let maxDeliveryDate = this.generateMaxDeliveryDate(loc[0])
													let currentCellDate = moment(this.state.dateRange[index], 'YYYY/MM/DD')
													let locationStyle = {...style}
													locationStyle["borderRadius"] = "3px"
													if( moment(currentCellDate).diff(maxDeliveryDate, 'day') > 0 ){
														locationStyle["backgroundColor"]= "#ffccc7"
													}else{
														locationStyle["backgroundColor"]= "#eaff8f"
													}
													return(
														<td style={locationStyle}>
															<Collapse style={{margin:'10px'}}>
																{
																	loc.map(location=>
																		<Panel
																			showArrow={false}
																			header={location.invNum} 
																			key={location._id}
																			style={{width:'250px',fontSize:'9px', backgroundColor:`${location.dateCompleted && "#bae637"}`}}
																			extra={
																				<Row type="flex" justify="end">
																					<Col>
																						{location.deliveryOption === "express" && <Tag color="red">Express</Tag> }
																					</Col>
																					<Col>
																						{location.deliveryOption === "standard" && <Tag color="cyan">Standard</Tag> }
																					</Col>
																					<Col>
																						{location.deliveryOption === "international" && <Tag color="blue">International</Tag> }
																					</Col>

																					<Col>
																						{location.deliveryMode === "Eezee Send" && <Tag color="blue">Eezee</Tag> }
																					</Col>
																					<Col>
																						{location.deliveryMode === "TCK Express" && <Tag color="purple">TCK</Tag> }
																					</Col>
																					<Col>
																						{location.deliveryMode === "Supplier Send" && <Tag color="gold">Supplier</Tag> }
																					</Col>
																					<Col>
																						{location.deliveryMode === "Janio" && <Tag color="blue">Janio</Tag> }
																					</Col>

																					<Col>
																						{location.locationActionRequired === "pickup" ? <StopTag location={location} color="magenta">P</StopTag> : <StopTag location={location} color="green">D</StopTag> }
																					</Col>
																					<Col>
																						{<Button size='small' icon='check' type={this.state.selectedLocations.includes(location._id) && 'primary'} disabled={location.dateCompleted} onClick={(e)=>this.selectLocation(e , location._id)}/>}
																					</Col>
																				</Row>
																			} 
																		>
																			<Col type="flex" justify="start" style={{textAlign:'left'}}>
                                                
																				<Row span={4} style={{textAlign: 'center', marginBottom:'10px'}}> 
																					{location.locationActionRequired === 'pickup' ? <Tag color="magenta">Pickup</Tag> : <Tag color="green">Delivery</Tag>}
																					<Tag color="cyan" >{location.address.zone}</Tag>
																				</Row>
																				
																				<Row style={{borderTop:'0.5px solid #d9d9d9', paddingTop:'10px'}} span={4}> <b>{location.address.name}</b> </Row>
																				<Row span={4} style={{marginBottom:'10px'}}> <b>{location.address.hp}</b> </Row>
																				<Row span={4}> <b>{location.address.companyName}</b> </Row>
																				<Row span={4}> <b>{location.address.address}</b> </Row>
																				<Row span={4}> <b>{location.address.unit}</b> </Row>
																				<Row span={4} style={{marginBottom:'10px'}} > <b>{location.address.postalCode}</b> </Row>

																				<Row span={4} style={{marginTop:'10px', marginBottom:'5px', borderTop:'0.5px solid #d9d9d9'}}>Products:</Row>
																				{location.products.map(_product=>
																					<Row span={4} style={{marginTop:'5px'}} key={_product._id}>
																						<b>{`${_product.productTitle}`}</b>
																						{`x${_product.quantity}`}
																					</Row>
																				)}
																			</Col> 
																		</Panel>
																	)
																}
															</Collapse>
														</td>
													)
												}
											})
										}
									</tr>
								)
							})
						}
					</tbody>
                    	
					<Row style={{position:'fixed', zIndex:'99999',bottom:'5px', width:'100%', left:320}} type="flex" justify="start" >
						<RangePicker style={{marginRight:'10px'}} format={'DD/MM/YYYY'} value={this.state.filterDateRange} onChange={this.onChangeDateFilter}/>
						<Popover
								visible = {this.state.datePickerPopover}
								placement="top"
								trigger="click"
								content={
									<div>
										<DatePicker
											size="large"
											format="DD/MM/YYYY"
											placeholder="Select Date and Time"
											value = {this.state.scheduledDate}
											onChange = {this.onChangeDate}
										/>
										<Button onClick={this.changeDateScheduled}>
											OK
										</Button>
									</div>
								}
							>
								<Button size='large' style={{marginRight:'10px'}} type='danger' onClick={(e)=>this.toggleDatePicker(e)} >Change Date</Button>
							</Popover>
							<Button style={{marginRight:'10px'}} size='large' type='danger' onClick={()=>this.changeDeliveryMode("TCK Express")}>Assign to TCK</Button>
							<Button style={{marginRight:'10px'}} size='large' type='danger' onClick={()=>this.changeDeliveryMode("Supplier Send")}>Assign to Supplier Send</Button>
					</Row>

					
				</table>
				</div>
							
				
			)
	}
	onFocusDate = (e , date) => {
		e.preventDefault()
		let focusDate
		if(this.state.focusDate != date && this.state.focusDate){
			focusDate = date
			message.loading(`Fetching all orders on ${date}`, 0)
		}
		if(this.state.focusDate === date){
			focusDate = null
			message.loading(`Fetching all uncompleted orders... This takes awhile`, 0)
		}
		if(!this.state.focusDate){
			focusDate = date
			message.loading(`Fetching all orders on ${date}`, 0)
		}
		
		_generateGantt(this.state.filterDateRange, focusDate)
		.then(res=>{
			message.destroy()
			message.success(`success`)
			this.setState({
				focusDate: focusDate,
				table: res.data.table,
				selectedLocations: [],
				countPerDay: res.data.countPerDay
			})
		})
	}
	onChangeDateFilter = (value) => {
		message.loading('loading... This takes awhile', 0)
		_generateGantt(value, this.state.focusDate)
				.then(res=>{
					message.destroy()
					message.success('Date range changed')
					this.setState({
						dateRange: res.data.date,
						table: res.data.table,
						selectedLocations: [],
						filterDateRange: value,
						countPerDay: res.data.countPerDay
					})
				})
	}
	generateMaxDeliveryDate = (location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }

        let maxDeliveryDate = moment(location.datePurchased, 'DD/MM/YY')
        let numOfWorkingDays = 0
       
        while(numOfWorkingDays < workingDays[location.deliveryOption]){
            let day = moment(maxDeliveryDate).add(1,'day').format('ddd')
            maxDeliveryDate = moment(maxDeliveryDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }
        return(maxDeliveryDate)
	}
	
	selectLocation = (e,id) => {
		e.stopPropagation()
		let array = [...this.state.selectedLocations]
		if(this.state.selectedLocations.includes(id)){
			array = array.filter(a=>a!=id)
		}else{
			array.push(id)
		}
		this.setState({
			selectedLocations: array
		})
	}
	onChangeDate = (value) => {
        this.setState({
            scheduledDate: value
        })
	}
	changeDateScheduled = () => {
		message.loading('changing date...', 0)
        _postNewDateScheduled(moment(this.state.scheduledDate).format("YYYY-MM-DD"), this.state.selectedLocations)
        .then(res=>{
			message.destroy()
			message.loading('Updating table data... This might take awhile', 0)
            if(res.data.status === "success"){
               let [startDate, endDate] = this.state.dateRange
                let start = moment(startDate).format('YYYY-MM-DD')
                let end = moment(endDate).format('YYYY-MM-DD')
                
				_generateGantt(this.state.filterDateRange, this.state.focusDate)
				.then(res=>{
					message.destroy()
					message.success('updated!')
					this.setState({
						dateRange: res.data.date,
						table: res.data.table,
						selectedLocations: [],
						datePickerPopover: false,
						countPerDay: res.data.countPerDay
					})
				})
            }
        })
        .catch(e=>console.log(e))
    }
	toggleDatePicker = (e) => {
        e.preventDefault()
        this.setState({
            datePickerPopover: !this.state.datePickerPopover
        })
	}
	changeDeliveryMode = (deliveryMode) => {
		message.loading('Changing Delivery Mode',0)
		_postNewDeliveryMode(deliveryMode, this.state.selectedLocations)
			.then(res=>{
				message.destroy()
				message.success('Delivery Mode changed')
				message.loading('updating table data', 0)
				if(res.data === "success"){
					let [startDate, endDate] = this.state.dateRange
					let start = moment(startDate).format('YYYY-MM-DD')
					let end = moment(endDate).format('YYYY-MM-DD')
					
					_generateGantt(this.state.filterDateRange, this.state.focusDate)
					.then(res=>{
						message.destroy()
						message.success('updated')
						this.setState({
							dateRange: res.data.date,
							table: res.data.table,
							selectedLocations: [],
							countPerDay: res.data.countPerDay
						})
					})
				}
			})
	}
}   

export default DeliveryRoutesTable


// WEBPACK FOOTER //
// ./src/components/delivery-page/deliveryRoutesTable.js